import { Component } from '@angular/core';
import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';

@Component({
  selector: 'app-buyer-logout',
  templateUrl: './buyer-logout.component.html',
  styleUrls: ['./buyer-logout.component.scss'],
  standalone: true,
})
export class BuyerLogoutComponent {
  constructor() {}
}
